<template>
    <tr class="package-message-row-component" :class="{selected: selected}" @click="onChangeSelect">
        <td class="half-padding">
            <a-checkbox
                    ref="checkbox"
                    :checked="selected"
                    @change="onChangeSelect"
                    @click.stop
            ></a-checkbox>
        </td>
        <td>
          <a @click.stop="openMessage">{{ afdMessage.message_id }}</a>
        </td>
        <td>
            <a v-if="hasCustomer" @click.stop="goToCustomerOverview">{{ formattedCustomer }}</a>
            <span v-else>Geen automatische koppeling</span>
        </td>
        <td>
            <afd-message-description-component :afd-message="afdMessage"></afd-message-description-component>
        </td>
        <td>
            {{ formattedAgency }}
        </td>
        <td>
            {{ formattedDate }}
        </td>
        <td>
            {{ afdMessage.package_number }}
        </td>
        <td>
            <a v-if="hasInstance" @click.stop="goToInstance">{{ instance.name }}</a>
            <span v-else>-</span>
        </td>
        <td class="compact">
            <a-button key="open" class="action-open" @click="openMessage" title="Openen">
                <eye-icon></eye-icon>
            </a-button>
            <a-button type=danger key="reject" class="action-reject" @click="rejectMessage" title="Afkeuren">
                <close-icon></close-icon>
            </a-button>
        </td>
    </tr>
</template>

<script>
import store from "../store";
import AfdMessageDescriptionComponent from "./AFDMessageDescriptionComponent.vue";
import {DateFormatEnum} from "~/enums";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "PackageMessageRowComponent",
  components: {AfdMessageDescriptionComponent},
  props: {
    afdMessage: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters({
      selectedMessages: "$_sivi/selectedUnprocessedPackageMessages",
    }),
    agency() {
      return this.hasAgency ? this.afdMessage.agency.data : null;
    },
    customer() {
      return this.hasCustomer ? this.afdMessage.customer.data : null;
    },
    formattedAgency() {
      return this.hasAgency ? this.agency.name : null;
    },
    formattedCustomer() {
      return this.hasCustomer ? this.customer.full_name : null;
    },
    formattedDate() {
      return moment(this.afdMessage.datetime)
        .format(DateFormatEnum.DISPLAY_DATE);
    },
    hasAgency() {
      return (this.afdMessage.agency !== null && typeof this.afdMessage.agency !== "undefined"
        && this.afdMessage.agency.data !== null && typeof this.afdMessage.agency.data !== "undefined");
    },
    hasCustomer() {
      return (this.afdMessage.customer !== null && typeof this.afdMessage.customer !== "undefined"
        && this.afdMessage.customer.data !== null && typeof this.afdMessage.customer.data !== "undefined");
    },
    hasInstance() {
      return (this.afdMessage.instance !== null && typeof this.afdMessage.instance !== "undefined"
        && this.afdMessage.instance.data !== null && typeof this.afdMessage.instance.data !== "undefined");
    },
    instance() {
      return this.hasInstance ? this.afdMessage.instance.data : null;
    },
    selected() {
      return this.selectedMessages.findIndex(x => x.id === this.afdMessage.id) >= 0;
    },
  },
  methods: {
    ...mapActions({
      rejectAfdMessage: "$_sivi/rejectUnprocessedPackageMessage",
    }),
    goToCustomerOverview() {
      if (this.hasCustomer) {
        window.location = `/customer/${this.customer.id}/overview`;
      }
    },
    goToInstance() {
      if (this.hasInstance) {
        window.location = this.instance.uri;
      }
    },
    onChangeSelect(e) {
      let shiftKey = false;

      if (typeof e.nativeEvent !== "undefined") {
        shiftKey = e.nativeEvent.shiftKey;
      }

      this.$emit("onChangeSelect", this.afdMessage, !this.selected, shiftKey);
    },
    openMessage() {
      window.location = `/afd/${this.afdMessage.id}/match/package`;
    },
    rejectMessage() {
      this.rejectAfdMessage(this.afdMessage.id)
        .then(() => {
          this.$notification.success({
            message: "Gelukt",
            description: "Het bericht is gemarkeerd als voltooid",
          });
        })
        .catch(() => {
          this.$notification.error({
            message: "Er ging iets mis",
            description: "Het is niet gelukt om het bericht af te keuren",
          });
        });
    },
  },
  created() {
    const STORE_KEY = "$_sivi";
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
};
</script>

<style scoped>
tr.selected {
    background-color: #1890ff1c !important;
}
</style>
